import React from 'react';

export default function SectionHeader({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <h2 className="dash-section-label mb-3.5 text-[11px] font-semibold uppercase">
      {children}
    </h2>
  );
}
